module.exports = __webpack_public_path__ + "static/img/map-300x169.053b30ee.png";